import {
    IListProductProps
} from '../../list-page/interfaces/interfaces';
import StarRating from '../../../ui/rating/star-rating';
import ProductListPrices from '../product-price/product-list-prices';
import ProductListPricesMerch from '../product-price/product-list-prices-merch';
import { getIsChina } from '../../../domain/hidden-data-provider';
import ProductImage from '../product-image/product-image';
import { sendGAListPageEvent } from '../../../domain/marketing/gtm-provider';
import ProductBuyButton from '../product-buy-button/product-buy-button';
import ProductTitle from '../product-title/product-title';
import CRSDataDetails from "../../custom-pages/product-course/src-data-details/src-data-details";
import CompareProducts from '../compare/compare-products';
import ProductSubscriptionTiersTextABTEST from "../subscription/sbs-tiers-text-abtest";
import {PlansPopupExported} from "../../subscriptions/components/plugins-popup/plans-popup-exported";
import {useState} from "react";

/**
 * Grid product item.
 * Used in list pages, in the grid view mode.
 */
const GridProduct = (props: IListProductProps) => {

    const { product, classes } = props;
    const isRatingVisible = product.rating > 0 && !getIsChina();
    const hasBadge = !!product.badgeText;
    const isFaded = product.isProductFadeOut !== null ? product.isProductFadeOut : false;
    const isExpectedShipping = product.expectedShipping ? product.expectedShipping : '' ;
    const [showSubscriptionPopup, setShowSubscriptionPopup] = useState(false);

    return (
        <div
            data-grid-product="true"
            key={ product.nodeID }
            className={`grid-item text-base text-gray-700 flex flex-col relative ${ hasBadge ? '' : 'no-badge'} ${ isFaded ? 'faded' : ''} ${ classes ? classes : '' }`}
            data-order={ product.mainOrder }
            data-docid={ product.documentID }>

            <ProductImage {...props} classes="mb-4"  style={{
                height: props?.imageHeight? '' : '200px'
            }} />

            <ProductTitle
                product={ product }
                removeTitleLink={ props.removeTitleLink }
                isGridTitle={ true }
                listName={ props.listName }
            />

            {
                props.isTaglineHidden !== true &&
                <div className="text-gray-500 mb-2" data-grid-tagline="true" dangerouslySetInnerHTML={{ __html: product.tagline }} />
            }

            <div data-grid-stars="true">
            {
                props.isRatingHidden !== true && isRatingVisible &&
                <div onClick={ evt => {
                    sendGAListPageEvent(product, props.listName);
                }}>
                    <StarRating
                        rating={ product.rating }
                        reviews={ product.reviewsTotal }
                        url={ product.documentUrlPath }
                        urlHash={ 'tab-reviews' }
                        className="mb-4"
                        gaEventName={ 'Click Reviews' }
                        gaEventValue={ product.documentName }
                    />
                </div>
            }
            </div>

            {
                props.useSrcDetails === true &&
                <div className="mb-4">
                    <CRSDataDetails numberOfPlugins={product.numberOfPlugins} numberOfLessons={product.numberOfLessons} courseDurationHours={product.courseDurationHours} colorIcons="#000000" classNameEx={"justify-start"} />
                </div>
            }

            {
                props.isPriceAreaHidden !== true &&
                <div className="mb-4 flex-1 h-full flex flex-col" onClick={ evt => {
                    sendGAListPageEvent(product);
                }}>
                    { props.priceCustomText !== '' && <div>{ props.priceCustomText }</div> }

                    {/*
                        !props.isIncludedInHidden && !product.note && !product.isProductOptions && sbsIncludedIn &&
                        <ProductSubscriptionTiers product={ product } isGrid={ true } />
                    */}

                    {
                        !product.note && !product.isProductOptions && product.skuEnabled && /* product.sbsIncludedIn === 0 && */
                        <ProductListPrices product={ product }
                                           isFirstRowHidden={props.isPriceFirstRowHidden}
                                           isSecondRowHidden={props.isPriceSecondRowHidden}
                                           isThirdRowHidden={props.isPriceThirdRowHidden}
                                           isClockHidden={props.isPriceClockHidden}
                                           isDiscountBadgeHidden={props.isPriceDiscountBadgeHidden}
                                           isGoogleShoppingFeed={ props.isGoogleShoppingFeed }
                        />
                    }

                    {
                        !product.note && product.isProductOptions &&
                        <ProductListPricesMerch product={ product }
                                            isFirstMerchRowHidden={props.isFirstMerchRowHidden}
                                            isClockHidden={props.isPriceClockHidden}
                        />
                    }

                    {/* expected shipping */}
                    { !props.isAccountPage && !props.isExpectedShippingHidden && <div>{isExpectedShipping}</div> }
                </div>
            }

            {/* buy button */}
            {
                props.isButtonAndNoteHidden !== true &&
                <>
                    { (!props.isAccountPage && product.note) && <div dangerouslySetInnerHTML={{__html: product.note}} /> }
                    { (!product.note || props.isAccountPage) && (props.children ? props.children : <ProductBuyButton product={ product } listName={ props.listName } />) }
                </>
            }

            {/* any additional content */}
            { props.additionalContent && <div>{ props.additionalContent }</div> }

            { !props.isSbsTextHidden && !props.isButtonAndNoteHidden &&
                /*<ProductSubscriptionTiersText product={ product } /> */
                <ProductSubscriptionTiersTextABTEST
                    subscribePopupVariants={props?.abtest_SubscribePopup}
                    product={ product }
                    returnFunc={() => setShowSubscriptionPopup(true)}
                />
            }

            {
                props.isCompareVisible && !product.note &&
                <CompareProducts
                    documentID={ product.documentID }
                    callback={ props.compareCallback }
                    compareType={ props.compareType }
                />
            }
            {showSubscriptionPopup && <PlansPopupExported close={() => setShowSubscriptionPopup(false)} product={props?.product} sbsIncludedIn={props?.product?.sbsIncludedIn} />}
        </div>
    )
};

export default GridProduct;